package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GetSpecialPrice(
    @SerialName("actionAmount")
    val actionAmount: ActionAmount?,
    @SerialName("actionDiscount")
    val actionDiscount: Double?,
    @SerialName("actionGroup")
    val actionGroup: Double?,
    @SerialName("cashRegisterId")
    val cashRegisterId: List<String>?,
    @SerialName("codeMWSt")
    val codeMWSt: String?,
    @SerialName("codeMWSt2")
    val codeMWSt2: String?,
    @SerialName("dateInterval")
    val dateInterval: DateInterval?,
    @SerialName("fullDiscount")
    val fullDiscount: Double?,
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("mode")
    val mode: Int?,
    @SerialName("name")
    val name: String?,
    @SerialName("price")
    val price: List<Double?>?,
    @SerialName("priceInCafe")
    val priceInCafe: List<Double?>?,
    @SerialName("timeInterval")
    val timeInterval: TimeInterval?,
    @SerialName("tradePrice")
    val tradePrice: List<TradePrice?>?,
    @SerialName("type")
    val type: Int?,
    @SerialName("__typename")
    val typename: String?,
    @SerialName("weekDays")
    val weekDays: Int?
)